import React, { useState } from "react";
import { Button } from "antd";

import { DrugPriceCalculatorModal } from "./DrugPriceCalculatorModal";
import CalculatorIcon from "../../assets/svg/CalculatorIcon";

export const DrugPriceCalculator = ({
  onConfirm,
  clearLocalData = false,
  shouldUpdate = true,
  disabled = false,
  papId,
  iconID = "drug-calculator-button"
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <>
      <Button
        id={iconID}
        disabled={disabled}
        type="text"
        style={{ padding: 0, paddingTop: 5 }}
        onClick={() => setVisible(true)}
      >
        <div style={{ display: "flex", justifyContent: "center" }}>
          <CalculatorIcon />
        </div>
      </Button>
      <DrugPriceCalculatorModal
        papId={papId}
        onConfirm={onConfirm}
        shouldUpdate={shouldUpdate}
        setVisible={setVisible}
        clearLocalData={clearLocalData}
        visible={visible}
      />
    </>
  );
};
